import { ApplicationState } from 'app/types-store';

export const selectMetadata = (state: ApplicationState) =>
  state.companyReport?.metadata;

export const selectEmails = (state: ApplicationState) =>
  state.companyReport?.emails;

export const selectUsePredefDate = (state: ApplicationState) =>
  state.companyReport?.usePredefDate;

export const selectFetchingReport = (state: ApplicationState) =>
  state.companyReport?.fetchingReport;

export const selectFetchingMetadata = (state: ApplicationState) =>
  state.companyReport?.fetchingMetadata;

export const selectEmailsValidation = (state: ApplicationState) =>
  state.companyReport?.emailsValidation;

export const selectValidateReportFilters = (state: ApplicationState) =>
  state.companyReport?.validateFilters;

export const selectScheduleDefinition = (state: ApplicationState) =>
  state.companyReport?.scheduleDefinition;

export const selectFetchingScheduleDefinition = (state: ApplicationState) =>
  state.companyReport?.fetchingScheduleDefinition;

export const selectScheduleDefinitionChanged = (state: ApplicationState) =>
  state.companyReport?.scheduleDefinitionChanged;

export const selectScheduleFailedConstraints = (state: ApplicationState) =>
  state.companyReport?.scheduleFailedConstraints;

export const selectFetchingSpecialReport = (state: ApplicationState) => 
  state.companyReport?.fetchingSpecialReport;
